import { ReactElement } from 'react';

import { useUpdateDependentForm } from '../../../../../contexts/UpdateDependentFormProviderGdf';
import { useLoadingStore } from '../../../../../stores/useLoadingStore';
import { GoForwardButton } from '../../../GoForwardButton';
import { ConfirmFormBase } from '../../../shared/ConfirmFormBase';

function SuccessMessage(): ReactElement {
  return (
    <>
      <h2 className="text-[2rem] font-semibold text-center text-primary-main">
        Suas informa��es foram recebidas com sucesso!
      </h2>
      <p className="font-normal mt-1 text-center mb-8">
        Caso o e-mail tenha sido preenchido corretamente, em breve, voc�
        receber� a confirma��o do benef�cio Odontol�gico subsidiado pelo Governo
        do Distrito Federal.
      </p>
      <p className="font-normal mt-1 text-center mb-8">
        Clique no bot�o abaixo para ir para tela de confirma��o.
      </p>
      <p className="font-normal font-semibold mt-1 text-center mb-8">
        Baixe o aplicativo da Odontogroup e encontre um dentista mais pr�ximo de
        voc�!
      </p>
    </>
  );
}

export function ConfirmForm(): ReactElement {
  const { handleSubmit, navigateToProposta } = useUpdateDependentForm();
  const loading = useLoadingStore(state => state.loading);

  return (
    <ConfirmFormBase onSubmit={handleSubmit(navigateToProposta)}>
      <SuccessMessage />
      <GoForwardButton
        disabled={loading}
        desktopText={loading ? '' : 'Finalizar compra'}
        mobileText={loading ? '' : 'Finalizar compra'}
      />
    </ConfirmFormBase>
  );
}
